import classNames from 'classnames'
import sanitize from 'sanitize-html'

import { TPopupHorizontal } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'

import styles from './CommentIcon.module.scss'

type Props = {
  tooltipText: string
}

export const CommentIcon = ({ tooltipText }: Props) => {
  return tooltipText ? (
    <Tooltip
      horizontalStartPosition={TPopupHorizontal.Right}
      horizontalDirection={TPopupHorizontal.Right}
      tipContent={() => (
        <div
          dangerouslySetInnerHTML={{
            __html: sanitize(tooltipText),
          }}
        />
      )}
    >
      <i className={classNames('kbase kbase-chat', styles.icon__comment)} />
    </Tooltip>
  ) : (
    <></>
  )
}
